export default "__VITE_ASSET__ca89c579__"